var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.items.length)?_c('nav',{staticClass:"party-subnav",attrs:{"aria-label":"二级栏目"}},_vm._l((_vm.items),function(item){return _c('button',{key:item.key,class:{ active: item.active },attrs:{"type":"button"},on:{"click":function($event){return _vm.$emit('select', item)}}},[_vm._v(_vm._s(item.label))])}),0):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }